import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PagesUserPermissionsManagerUiDisplay from "./Display/PermissionsSearchInput";
import { PagesUserPermissionsManagerUiResults } from "./Display/Results";
import { Alert, Button } from "@dealer-center/core-components";
import styled from "styled-components";

const StyledNoAccess = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export function PagesUserPermissionsManagerParentUiDisplay() {
  useEffect(() => {
    document.title = "User Permissions Manager";
  }, []);
  const { userId } = useParams();
  const navigate = useNavigate();
  const {
    "cc9.user-permissions-manager.enable": shouldDisplayPermissionsManagerUi
  } = useCC9Flags();

  return shouldDisplayPermissionsManagerUi ? (
    <div>
      <PagesUserPermissionsManagerUiDisplay />
      {userId && <PagesUserPermissionsManagerUiResults />}
    </div>
  ) : (
    <StyledNoAccess>
      <Alert title="Access Denied" type="error">
        <span>{"You don't have access to User Permissions Manager"}</span>
      </Alert>
      <div>
        <Button
          analyticsConfiguration={{
            eventName: "ReturnToAccountSearch",
            eventProperties: undefined
          }}
          buttonStyle="primary"
          data-testid="button-data-testid"
          id="ReturnToAccountSearch"
          size="medium"
          onClick={() => {
            navigate("/account-search");
          }}
        >
          Return to Account Search
        </Button>
      </div>
    </StyledNoAccess>
  );
}
